import React from "react";

interface Tab {
  id: string;
  title: string;
  icon?: React.ReactNode;
}

interface TabsProps {
  className?: string;
  tabs: Tab[];
  activeTab: string;
  onChange: (tab: Tab) => void;
}

const Tabs: React.FC<TabsProps> = ({
  className,
  tabs = [],
  activeTab,
  onChange,
}) => {
  return (
    <div
      className={`flex items-center justify-center gap-1 p-1.5 rounded-full border border-gray-200 shadow-lg ${className}`}
    >
      {tabs?.map((tab) => (
        <button
          key={tab?.id}
          type="button"
          className={`flex-1 h-full flex items-center justify-center gap-1.5 text-sm font-medium px-3 py-1.5 ${
            activeTab === tab?.id
              ? "bg-[linear-gradient(to_right,var(--app-primary),var(--app-primary-hover))] text-white rounded-full"
              : "bg-transparent text-gray-500"
          }`}
          onClick={() => onChange(tab)}
        >
          {tab.icon}
          <span>{tab.title}</span>
        </button>
      ))}
    </div>
  );
};

export default Tabs;
